import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const CreateTicket = createApi({
    reducerPath: "createTicket",
    baseQuery: dynamicBaseQuery,
    refetchOnMountOrArgChange: true,

    endpoints: (builder) => ({
        createTicket: builder.mutation({
            query: (body) => ({
                url: `v1/tickets/ticket/`,
                method: "POST",
                body,
            }),
        }),

        disposition: builder.query({
            query: (getTeamId) => ({
                url: `/v1/common/disposition/?team_id=${getTeamId}&`,
                method: "GET",
            }),
        }),

        getDispositionStatus: builder.query({
            query: (lastSelectedId) => ({
                url: `v1/common/disposition/${lastSelectedId}/lookup_by_disposition/?`,
                method: "GET",
            }),
        }),

        ticketDynamicFields: builder.query({
            query: () => ({
                url: "v1/common/dynamic-field-definitions/?model_name=ticket_name&",
                method: "GET",
            }),
        }),

        ticketDynamicFieldsByDisposition: builder.query({
            query: (ticket_name_id) => ({
                url: `v1/common/dynamic-field-definitions/?model_name=ticket_name&ticket_name=${ticket_name_id}&lazy_multiple_level=true`,
                method: "GET",
            }),
        }),

        createScheduler: builder.mutation({
            query: (body) => ({
                url: `v1/tickets/auto-ticket-scheduler/`,
                method: "POST",
                body,
            }),
        }),

        updateScheduler: builder.mutation({
            query: ({ body, id }) => ({
                url: `v1/tickets/auto-ticket-scheduler/${id}/`,
                method: "PATCH",
                body,
            }),
        }),

        updateDisposition: builder.mutation({
            query: ({ body, id }) => ({
                url: `/v1/tickets/ticket/${id}/`,
                method: "PATCH",
                body,
            }),
        }),

        ticketDetailsAfterSelectingDisposition: builder.query({
            query: (id) => ({
                url: `v1/tickets/ticket/${id}/`,
                method: "GET",
            }),
        }),

        updateTicketWorkflow: builder.mutation({
            query: ({ id, body }) => ({
                url: `/v1/tickets/ticket/${id}/`,
                method: "PATCH",
                body,
            }),
        }),

        ticketDetailsAfterSelectingDispositionWithMultiLevel: builder.query({
            query: (id) => ({
                url: `v1/tickets/ticket/${id}?multi_level_path=true`,
                method: "GET",
            }),
        }),

        markTicketActionable: builder.mutation({
            query: (id) => ({
                url: `v1/tickets/mark-actionable/${id}/`,
                method: "POST",
            }),
        }),


        ticketNameRulesAll: builder.query({
            query: ({ selectedTeam, lastSelectedId, selectedWorkflow }) => ({
                url: `v1/tickets/ticket-name-rules-all/${selectedTeam}/${lastSelectedId}/${selectedWorkflow}/?filter=true`,
                method: "GET",
            }),
        }),

        updateTicketNameRulesAll: builder.mutation({
            query: ({ body, selectedTeam, lastSelectedId, selectedWorkflow }) => ({
                url: `v1/tickets/ticket-name-rules/${selectedTeam}/${lastSelectedId}/${selectedWorkflow}/`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useUpdateTicketWorkflowMutation,
    useTicketDetailsAfterSelectingDispositionQuery,
    useTicketDetailsAfterSelectingDispositionWithMultiLevelQuery,
    useUpdateDispositionMutation,
    useCreateTicketMutation,
    useDispositionQuery,
    useGetDispositionStatusQuery,
    useTicketDynamicFieldsQuery,
    useTicketDynamicFieldsByDispositionQuery,
    useCreateSchedulerMutation,
    useUpdateSchedulerMutation,
    useMarkTicketActionableMutation,
    useTicketNameRulesAllQuery,
    useUpdateTicketNameRulesAllMutation,
} = CreateTicket;
